import React from 'react';
import { DropdownContainer } from 'shared/components/Dropdown/Dropdown';

interface FundDropdownProps {
  selected: string | undefined;
  options: string[];
  onChange: (fund: string) => void;
}

export const FundDropdown: React.FC<FundDropdownProps> = ({
  selected,
  options,
  onChange,
}) => {
  return (
    <DropdownContainer
      labelText="Fund"
      value={selected}
      options={options}
      onChange={onChange}
      verticalLayout
    />
  );
};
